module.exports = __webpack_public_path__ + "fonts/Barlow-Medium.f085fe17.woff";